<template>
  <Modal ref="modal" title="Relatório de Alunos Cadastrados" @cancel="close">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <form v-else class="export-container" @submit.prevent="handleSubmit">
      <Select class="input-full" :options="schemaOptions" legend="Autoescola" placeholder="Selecione"
        :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" :disabled="loading" />

      <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
        @update:firstModelValue="$event => (this.initialDate = $event)"
        @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Period from 'core/Period'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'AlunosCadastradosModal',
  components: {
    Modal,
    LoadingSpinner,
    Select,
    Period,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      schema: '',
      initialDate: '',
      finalDate: '',
      schemaOptions: [],
      loaded: false,
      loading: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()

      await this.fetchCfcs()

      this.loaded = true
    },
    close() {
      this.$refs.modal.close()

      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.loaded = false
      this.loading = false
    },
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados
            .filter(cfc => cfc.nome_fantasia !== "TESTE")
            .map(cfc => ({
              value: cfc.tenant_schema,
              text: cfc.nome_fantasia
            }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/alunos/relatorio/cadastrados/${this.initialDate}/${this.finalDate}`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'alunos-cadastrados')
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma autoescola.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      if (!this.initialDate || !this.finalDate) {
        this.$toasted.show('Os campos de período são obrigatórios.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      const initial = new Date(this.initialDate)
      const final = new Date(this.finalDate)

      if (final < initial) {
        this.$toasted.show('A data final deve ser menor que a data inicial!', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 20vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  button {
    justify-content: center;
  }
}
</style>